import React, { useState } from 'react';
import { logData } from '../../api';
import { SHARE_TEXT, SITE_URL } from './content';
import { trackEvent } from './track';

// Îndemn de trimis cursul mai departe, afișat după înscriere.
const ShareBox = () => {
    const [copied, setCopied] = useState(false);

    const logShare = (channel) => {
        logData("share", { channel: channel }).catch(() => { });
        trackEvent('share', { method: channel, content_type: 'course' });
    };

    const copyLink = async () => {
        logShare("copy");
        try {
            await navigator.clipboard.writeText(SITE_URL);
            setCopied(true);
            setTimeout(() => setCopied(false), 2500);
        } catch {
            window.prompt("Copiază linkul:", SITE_URL);
        }
    };

    return (
        <div className="lp-share">
            <p className="lp-share__title">Știi pe cineva care îl crede pe ChatGPT pe cuvânt? Trimite-i linkul.</p>
            <div className="lp-share__buttons">
                <a
                    className="lp-btn lp-btn--ghost"
                    href={`https://wa.me/?text=${encodeURIComponent(SHARE_TEXT)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => logShare("whatsapp")}
                >
                    Trimite pe WhatsApp
                </a>
                <button type="button" className="lp-btn lp-btn--ghost" onClick={copyLink}>
                    {copied ? 'Link copiat ✓' : 'Copiază linkul'}
                </button>
            </div>
        </div>
    );
};

export default ShareBox;
